import type { PathwayScreen } from '../hooks/use-config-api';

import { getAbsoluteRoute } from './get-absolute-route';

export const getRouteForReturnScreen = (
    drxId: string,
    returnScreen?: PathwayScreen
): string => {
    switch (returnScreen) {
        case 'coverage-select':
            return getAbsoluteRoute('fill.drxId.coverageSelect', { drxId });
        case 'coverage-sub-select':
            return getAbsoluteRoute('fill.drxId.coverageSubSelect', { drxId });
        case 'on-hold':
            return getAbsoluteRoute('fill.drxId.onHold', { drxId });
        case 'path-select':
            return getAbsoluteRoute('fill.drxId.pathSelect', { drxId });
        case 'pharmacy-preview':
        case 'pharmacy-select':
            return getAbsoluteRoute('fill.drxId.pharmacy.root', { drxId });
        case 'switch':
            return getAbsoluteRoute('fill.drxId.switch', { drxId });
        default:
            return getAbsoluteRoute('fill.drxId.root', { drxId });
    }
};
